<template>
  <div class="form-row">
    <ElFormItem prop="user_role" class="full-width">
      <AppSelect
        v-model="store.formData.user_role"
        label="I'm a..."
        :options="userRoleOptions"
        placeholder="Select your role"
        size="large"
        :required="true"
      />
    </ElFormItem>
  </div>

  <div class="form-row">
    <ElFormItem prop="location_type" class="full-width">
      <AppSelect
        v-model="store.formData.location_type"
        label="Location Type"
        :options="locationTypeOptions"
        placeholder="Select location type"
        size="large"
        :required="true"
      />
    </ElFormItem>
  </div>

  <div class="form-row">
    <ElFormItem prop="project_type" class="full-width">
      <AppLabel for="project_type" required>Project Type</AppLabel>
      <ProjectTypeSelector v-model="store.formData.project_type" />
    </ElFormItem>
  </div>
</template>

<script setup>
import { ElFormItem } from "element-plus";
import { AppLabel, AppSelect } from "@/components/ui";
import { userRoleOptions, locationTypeOptions } from "@/utilities/collections/newReportOptions";
import ProjectTypeSelector from "@/views/NewReportView/components/ProjectTypeSelector.vue";
import { useReportFormStore } from "@/stores/reportFormStore";

const store = useReportFormStore();
</script>
